import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import './ShareArticle.scss';

@Component
export class ShareArticle extends ThemeComponent {

    constructor() {
        super();
    }

    init() {
        const shareButtons:  NodeListOf<HTMLElement>
            = document.querySelectorAll('.article-main__social-label');
        for (const shareButton of shareButtons) {
            this.$listen(shareButton, 'click', (event) => {
                navigator.clipboard.writeText(window.location.href).then(() => {
                    shareButton.classList.add('article-main__social-label--copied');

                    setTimeout(() => {
                        shareButton.classList.remove('article-main__social-label--copied');
                    }, 800);
                }).catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error('Failed to copy: ', err);
                });
            });
        }
    }
}
